type VerifyError = (e: string) => boolean;

export const isCustomerNotFoundError: VerifyError = e =>
  e === 'CustomerNotFound';

export const isInternalServerErr: VerifyError = e =>
  e === 'InternalServerError';
